import {svgs, IconProps} from 'epic-diesel-common';

export interface Route {
    path: string;
    label: string;
    icon?: IconProps['icon'];
}

export type RouteConfigKeys =
    | 'overview'
    | 'news'
    | 'dashboard'
    | 'payout'
    | 'settings'
    | 'fortniteGames';

export type RouteConfigs = {
    [key in RouteConfigKeys]: Route;
};

export enum FortniteGamesTab {
    Insights = 'insights',
    Performance = 'performance',
    Playrate = 'playrate',
    GameXp = 'xp',
    Rewards = 'rewards'
}

export const getRouteConfigs = (tab?: FortniteGamesTab) => {
    const activeTab = tab || FortniteGamesTab.Insights;

    const routeMap: RouteConfigs = {
        overview: {
            path: 'overview',
            label: 'epic.affiliate.nav.overview'
        },
        news: {
            path: 'news',
            label: 'epic.affiliate.nav.news'
        },
        dashboard: {
            path: 'dashboard',
            label: 'epic.affiliate.nav.dashboard.v2'
        },
        payout: {
            path: 'payout',
            label: 'epic.affiliate.nav.payout'
        },
        settings: {
            path: 'settings',
            label: 'epic.affiliate.nav.settings'
        },
        fortniteGames: {
            path: `fortnite-games/${activeTab}`,
            label: 'epic.affiliate.nav.fortnite_games',
            icon: svgs.ANALYTICS
        }
    };

    return {
        routeMap,
        routes: Object.values(routeMap)
    };
};

export default getRouteConfigs;
